import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { baseUrl } from "../../api/baseUrl";

const API_BASE_URL = `${baseUrl}/api/v1/provider/`;

// Enhanced base query with network error handling
const branchesBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = Cookies.get("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const branchesBaseQueryWithErrorHandling = async (args, api, extraOptions) => {
  const result = await branchesBaseQuery(args, api, extraOptions);

  // Check for network connectivity errors
  if (result.error) {
    const { status, error } = result.error;

    if (
      status === "FETCH_ERROR" ||
      status === "TIMEOUT_ERROR" ||
      error === "Failed to fetch" ||
      error === "NetworkError" ||
      !navigator.onLine
    ) {
      console.log("Branches API network error detected:", result.error);

      // Trigger the NoInternetConnection component
      window.dispatchEvent(
        new CustomEvent("network-error", {
          detail: {
            error: result.error,
            source: "branchesApi",
            timestamp: Date.now(),
          },
        })
      );
    }
  }

  return result;
};

export const branchesApi = createApi({
  reducerPath: "branchesApi",
  baseQuery: branchesBaseQueryWithErrorHandling,
  tagTypes: ["Branches"],
  endpoints: (builder) => ({
    getBranches: builder.query({
      query: () => "brand/branches",
      providesTags: ["Branches"],
    }),
    deleteBranch: builder.mutation({
      query: (branchId) => ({
        url: `branch/${branchId}/remove`,
        method: "DELETE",
      }),
      invalidatesTags: ["Branches"],
    }),
    updateBranch: builder.mutation({
      query: ({ branchId, data }) => ({
        url: `branch/${branchId}/update`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Branches"],
    }),
  }),
});

export const {
  useGetBranchesQuery,
  useDeleteBranchMutation,
  useUpdateBranchMutation,
} = branchesApi;
